import { GeoLocation } from '../model/geoLocation';

export interface GeoCoordinates {
  lat: number;
  lng: number;
}

export function parseCoordinate(value: string | number | null | undefined): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const parsed = typeof value === 'number' ? value : Number(String(value).trim().replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function parseCoordinates(location?: GeoLocation | null): GeoCoordinates | null {
  if (!location) {
    return null;
  }

  const lat = parseCoordinate(location.lat) ?? parseCoordinate(location.latitude);
  const lng = parseCoordinate(location.lon) ?? parseCoordinate(location.longitude);

  if (lat == null || lng == null || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return null;
  }

  return { lat, lng };
}
